import React from 'react';
import { Image, Rect } from 'react-konva';
import { animateToFocusThenFetchTreeSaga, isMobilePhone } from '../../library/calc';
import { editTreeActionIconTop, editTreeActionOpacity,  cachetree } from '../../library/constants';

export class Treelink extends React.Component {

  constructor(props){
    super(props);
    this.props.buildRefObj({key: `tree_n-${this.props.n}`, objClass: this});
  }

  state = {
    hovering: false,
  }

  click(){

      let {
        pr_id,
        setPrId,
        fetchTree,
        callSetPageProfile,
        setDidRequestLoadTreeToTrue,
        setStageClickCanZoomStep,
        unSetStageClickCanZoomStep,
        panAnimateToNode,
        node,
        setNextNodeForPruning,
        setPushToHistory,
        reloadWithNewTree,
        zoomOutFromMobileFlipCard,
        showProgressIndicator,
        toggleFlipPanel,
        userTouchedNode,
        setFlipPanelOpenAfterAnimateComplete,
        toggleNavigationalPanel,
        resetNavigationState,
        isPedigree,
        setPedigreeAddbox,
        reloadCanvasTree,
      } = this.props;

    if(isPedigree){
      setPedigreeAddbox({visible:false})
      reloadCanvasTree(pr_id);
      return;
    }
    this.props.resetNavDirectionControls();
    this.props.hideProductTour({fromWhere: 'K', withLastStepNotify: true});
    this.props.unhighlight();
    animateToFocusThenFetchTreeSaga({
      pr_id,
      node,
      setPrId,
      fetchTree,
      callSetPageProfile,
      setDidRequestLoadTreeToTrue,
      setStageClickCanZoomStep,
      unSetStageClickCanZoomStep,
      panAnimateToNode,
      setNextNodeForPruning,
      setPushToHistory,
      reloadWithNewTree,
      zoomOutFromMobileFlipCard,
      showProgressIndicator,
      toggleFlipPanel,
      userTouchedNode,
      setFlipPanelOpenAfterAnimateComplete,
      toggleNavigationalPanel,
      resetNavigationState,
    });
  }

  testMethod(){
      console.log(`%cTreelink testMethod is executed for node: ${this.props.node} `, [
      'color: white',
      'background: black',
      'font-size: 19px',
      'border: 5px solid red',
      'padding: 10px',
      ].join(';'));
  }

  callHover(hover){
    this.setState({hover})
  }

  componentDidUpdate(){
    if(cachetree){
      this.refs.treeNodeCache.cache();
    }
  }

  render() {

      let {
        left,
        top,
        cursorBecomesMove,
        cursorBecomesPointer,
        treeImg,
        isPedigree,
        pedigreeIsTall/*,
        pr_id,
        setPrId,
        fetchTree,
        callSetPageProfile,
        setDidRequestLoadTreeToTrue,
        setStageClickCanZoomStep,
        unSetStageClickCanZoomStep,
        panAnimateToNode,
        node,
        setNextNodeForPruning,
        setPushToHistory,
        reloadWithNewTree,
        zoomOutFromMobileFlipCard,
        showProgressIndicator,
        toggleFlipPanel,
        userTouchedNode,
        setFlipPanelOpenAfterAnimateComplete,
        toggleNavigationalPanel,
        resetNavigationState,
        setPedigreeAddbox*/,
      } = this.props;


    left += 62.5;
    const pedigreeTop = ( pedigreeIsTall ? -8: -14);
    top += editTreeActionIconTop + ( isPedigree ? pedigreeTop: 0);

    return <Image
      ref={'treeNodeCache'}
      listening={false}
      image={treeImg}
      onClick={this.click.bind(this)}
      x={left}
      y={top}
      scaleX={.1}
      scaleY={.1}
      width={6 * 10}
      height={3.5 * 10}
      opacity={( ( this.state.hover ? 1: editTreeActionOpacity) )}
      // onTouchStart={(e)=>{
      //   if(isPedigree) setPedigreeAddbox({visible:false});
      //   this.props.resetNavDirectionControls();
      //   this.props.hideProductTour({fromWhere: 'H', withLastStepNotify: true});
      //   this.props.unhighlight();
      //   animateToFocusThenFetchTreeSaga({
      //     pr_id,
      //     node,
      //     setPrId,
      //     fetchTree,
      //     callSetPageProfile,
      //     setDidRequestLoadTreeToTrue,
      //     setStageClickCanZoomStep,
      //     unSetStageClickCanZoomStep,
      //     panAnimateToNode,
      //     setNextNodeForPruning,
      //     setPushToHistory,
      //     reloadWithNewTree,
      //     zoomOutFromMobileFlipCard,
      //     showProgressIndicator,
      //     toggleFlipPanel,
      //     userTouchedNode,
      //     setFlipPanelOpenAfterAnimateComplete,
      //     toggleNavigationalPanel,
      //     resetNavigationState,
      //   });
      // }}

      // onClick={()=>{
      //   if(isMobilePhone() ) return;
      //   if(isPedigree) setPedigreeAddbox({visible:false})
      //   this.props.resetNavDirectionControls();
      //   this.props.hideProductTour({fromWhere: 'I', withLastStepNotify: true});
      //   this.props.unhighlight();
      //   animateToFocusThenFetchTreeSaga({
      //     pr_id,
      //     node,
      //     setPrId,
      //     fetchTree,
      //     callSetPageProfile,
      //     setDidRequestLoadTreeToTrue,
      //     setStageClickCanZoomStep,
      //     unSetStageClickCanZoomStep,
      //     panAnimateToNode,
      //     setNextNodeForPruning,
      //     setPushToHistory,
      //     reloadWithNewTree,
      //     zoomOutFromMobileFlipCard,
      //     showProgressIndicator,
      //     toggleFlipPanel,
      //     userTouchedNode,
      //     setFlipPanelOpenAfterAnimateComplete,
      //     toggleNavigationalPanel,
      //     resetNavigationState,
      //   });
      // }}

      onMouseenter={()=>{
        cursorBecomesPointer();
      }}
      onMouseleave={()=>{
        cursorBecomesMove();
      }}


    />;
  }
}



export class TransparentTreeBox extends React.Component {

  clickedOnce = false;

  render () {

      let {
        left,
        top,
        pr_id,
        setPrId,
        fetchTree,
        callSetPageProfile,
        setDidRequestLoadTreeToTrue,
        setStageClickCanZoomStep,
        unSetStageClickCanZoomStep,
        panAnimateToNode,
        node,
        setNextNodeForPruning,
        setPushToHistory,
        reloadWithNewTree,
        zoomOutFromMobileFlipCard,
        showProgressIndicator,
        toggleFlipPanel,
        userTouchedNode,
        setFlipPanelOpenAfterAnimateComplete,
        toggleNavigationalPanel,
        resetNavigationState,
        cursorBecomesMove,
        cursorBecomesPointer,
        focus,
        isPedigree,
        setPedigreeAddbox,
        reloadCanvasTree,
        pedigreeIsTall,
      } = this.props;

    const pedigreeTop = ( pedigreeIsTall ? -8: -13);
    top += editTreeActionIconTop + ( isPedigree ? pedigreeTop: 0);
    left +=( focus ? 64.6: 57.8);
    top -= 2;
    left += 4.3;
/*
              strokeWidth={0}
              stroke={'black'}

 */
    return  <Rect
              x={left}
              y={top}
              width={8}
              height={8}
              cursor="pointer"
              perfectDrawEnabled={false}


              onTouchStart={(e)=>{
                if(isPedigree) setPedigreeAddbox({visible:false})
                this.props.resetNavDirectionControls();
                this.props.hideProductTour({fromWhere: 'J', withLastStepNotify: true});
                this.props.unhighlight();
                animateToFocusThenFetchTreeSaga({
                  pr_id,
                  node,
                  setPrId,
                  fetchTree,
                  callSetPageProfile,
                  setDidRequestLoadTreeToTrue,
                  setStageClickCanZoomStep,
                  unSetStageClickCanZoomStep,
                  panAnimateToNode,
                  setNextNodeForPruning,
                  setPushToHistory,
                  reloadWithNewTree,
                  zoomOutFromMobileFlipCard,
                  showProgressIndicator,
                  toggleFlipPanel,
                  userTouchedNode,
                  setFlipPanelOpenAfterAnimateComplete,
                  toggleNavigationalPanel,
                  resetNavigationState,
                });
              }}

              onClick={()=>{

                /*
                  HACK
                    The following hack fixes bug where tree is immobilized when user double clickes tree link
                 */

                if( this.clickedOnce ) return;
                this.clickedOnce = true;

                /*
                  END HACK
                 */

                if(isMobilePhone() ) return;
                if(isPedigree){
                  setPedigreeAddbox({visible:false})
                  reloadCanvasTree(pr_id);
                  return;
                }
                this.props.resetNavDirectionControls();
                this.props.hideProductTour({fromWhere: 'K', withLastStepNotify: true});
                this.props.unhighlight();
                animateToFocusThenFetchTreeSaga({
                  pr_id,
                  node,
                  setPrId,
                  fetchTree,
                  callSetPageProfile,
                  setDidRequestLoadTreeToTrue,
                  setStageClickCanZoomStep,
                  unSetStageClickCanZoomStep,
                  panAnimateToNode,
                  setNextNodeForPruning,
                  setPushToHistory,
                  reloadWithNewTree,
                  zoomOutFromMobileFlipCard,
                  showProgressIndicator,
                  toggleFlipPanel,
                  userTouchedNode,
                  setFlipPanelOpenAfterAnimateComplete,
                  toggleNavigationalPanel,
                  resetNavigationState,
                });
              }}

              onMouseenter={()=>{
                const hovering = true;
                this.props.callRefObj({key: `tree_n-${this.props.n}`, method: 'callHover', param: hovering})
                cursorBecomesPointer();
              }}
              onMouseleave={()=>{
                const hovering = false;
                this.props.callRefObj({key: `tree_n-${this.props.n}`, method: 'callHover', param: hovering})
                cursorBecomesMove();
              }}

            />

  }
}
